import { render, staticRenderFns } from "./TicketDetailsOld.vue?vue&type=template&id=1ac6c4da&scoped=true"
import script from "./TicketDetailsOld.vue?vue&type=script&lang=js"
export * from "./TicketDetailsOld.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailsOld.vue?vue&type=style&index=0&id=1ac6c4da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac6c4da",
  null
  
)

export default component.exports